import { createContext, use } from 'react';
import type { Clinic, ClinicLookupFn } from './types';

type ClinicLookupContextValue = {
  clinicLookupFn?: ClinicLookupFn;
};

const ClinicLookupContext = createContext<ClinicLookupContextValue | undefined>(
  undefined,
);

export const ClinicLookupProvider = ({
  clinicLookupFn,
  children,
}: ClinicLookupContextValue & { children: React.ReactNode }) => {
  return (
    <ClinicLookupContext value={{ clinicLookupFn }}>
      {children}
    </ClinicLookupContext>
  );
};

export const useClinicLookup = (): ((params: {
  appointmentTypeId: string;
}) => Clinic | undefined) => {
  const context = use(ClinicLookupContext);

  return (params: { appointmentTypeId: string }) => {
    return context?.clinicLookupFn?.(params);
  };
};
